var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobilee60C2Fbc3Dcefa4256E0569Ffba5E523(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#635FC7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 25,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 9,
    width: 6,
    height: 25,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 18,
    width: 6,
    height: 25,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobilee60C2Fbc3Dcefa4256E0569Ffba5E523);
export default __webpack_public_path__ + "static/media/logo-mobile.e60c2fbc3dcefa4256e0569ffba5e523.e60c2fbc3dcefa4256e0569ffba5e523.svg";
export { ForwardRef as ReactComponent };